
import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import EqifyRuleComponent from "@/components/rules/components/EqifyRuleComponent.vue";

@Component({
  components: {EqifyRuleComponent}
})
export default class EqifyRuleRegistrationHasOutOfCompetition extends Vue {
  @Prop() value?: {
    value: boolean,
    required: boolean
  }

  options = [{text: this.$t('general.rules.true'), value: true}, {text: this.$t('general.rules.false'), value: false}]

  get outOfCompetition(): boolean {
    return this.value?.value || false
  }

  set outOfCompetition(val: boolean) {
    this.$emit("input", {
      value: val,
      required: this.required,
    })
  }

  get required(): boolean {
    if (this.value == undefined) {
      return true
    } else {
      return this.value.required
    }
  }

  set required(val: boolean) {
    this.$emit("input", {
      value: this.outOfCompetition,
      required: val,
    })
  }
}

